module.exports = __webpack_public_path__ + "static/media/community-share-image.629ea7e7.jpg";